import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from "react";
import useWallet from "../../../../../hooks/useWallet";
import { Selector, SelectorContent, SelectorTrigger } from "../../../../../components/Select/Selector/Index";
import { Content } from "../../../../../components/Input/RoutePicker/Content";
import { groupRoutes } from "../../../../../hooks/useFormRoutes";
import { useRecentNetworksStore } from "../../../../../stores/recentRoutesStore";
import { useRouteSortingStore } from "../../../../../stores/routeSortingStore";
import useSuggestionsLimit from "../../../../../hooks/useSuggestionsLimit";
import useDepositAddressAvailableRoutes from "../../../../../hooks/useDepositAddressAvailableRoutes";
import { useSwapRouteRecency } from "../../../../../stores/swapRouteHistoryStore";
import { PayFromTriggerContent, payFromTriggerClassName } from "./PayFromTriggerView";
const PayFromPicker = ({ selectedSource, onSourceChange, destinationNetwork, destinationToken, hideDestinationPicker }) => {
    const [searchQuery, setSearchQuery] = useState('');
    const { wallets } = useWallet();
    const { suggestionsLimit } = useSuggestionsLimit({ hasWallet: wallets.length > 0 });
    const sortingOption = useRouteSortingStore((s) => s.sortingOption);
    const routesHistory = useRecentNetworksStore(state => state.recentRoutes);
    const swapRecency = useSwapRouteRecency();
    const { availableRoutes } = useDepositAddressAvailableRoutes(destinationNetwork, destinationToken);
    const routeElements = useMemo(() => {
        return groupRoutes({
            routes: availableRoutes,
            direction: 'from',
            balances: null,
            groupBy: 'token',
            recents: routesHistory,
            swapRecency,
            balancesLoaded: false,
            search: searchQuery,
            suggestionsLimit,
            sortingOption,
            skipBalanceGate: true,
            hideSuggestions: true,
        });
    }, [availableRoutes, searchQuery, routesHistory, swapRecency, suggestionsLimit, sortingOption]);
    // Disable until the destination resolves a non-empty source list.
    const hasOptions = availableRoutes.length > 0;
    const hasMultipleOptions = availableRoutes.length > 1 || availableRoutes.some(r => r.tokens.length > 1);
    return (_jsxs("div", { className: "flex items-center gap-2", children: [!hideDestinationPicker && _jsx("span", { className: "w-24 shrink-0 text-sm text-secondary-text tracking-wide", children: "Send" }), _jsx("div", { className: "flex-1 min-w-0", children: _jsxs(Selector, { children: [_jsx(SelectorTrigger, { disabled: !hasOptions || !hasMultipleOptions, className: payFromTriggerClassName(hideDestinationPicker), children: _jsx(PayFromTriggerContent, { selectedSource: selectedSource, hasMultipleOptions: hasMultipleOptions, hideDestinationPicker: hideDestinationPicker }) }), _jsx(SelectorContent, { isLoading: false, children: ({ closeModal }) => (_jsx(Content, { onSelect: (r, t) => { onSourceChange(r, t); closeModal(); }, searchQuery: searchQuery, setSearchQuery: setSearchQuery, rowElements: routeElements, direction: "from", selectedRoute: selectedSource?.network.name, selectedToken: selectedSource?.token.symbol, hideTokenSwitch: true, hideBalances: true, hideConnectButton: true })) })] }) })] }));
};
export default PayFromPicker;
